import React, {
  MouseEvent,
  useCallback,
} from 'react';
import clsx from 'clsx';
import Button from 'pages/Dashboard/components/Button';
import Spinner from 'pages/Dashboard/components/Spinner';
import {
  useNotify,
} from 'core/hooks';
import {
  useCCMForCallPatient,
} from 'pages/Dashboard/pages/Appointments/pages/List/hooks';

type Props = {
  patientId: number;
  disabled?: boolean;
  className?: string;
};

export default function CallForCCMButton({ patientId, disabled, className }: Props) {
  const notify = useNotify();
  const {
    mutateAsync: initiateCCMCall,
    isPending: isLoading,
  } = useCCMForCallPatient();

  const handleClick = useCallback(async (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    await initiateCCMCall({ patientId });
    notify({
      variant: 'success',
      message: 'Call for CCM initiated.',
    });
  }, [initiateCCMCall, notify, patientId]);

  return (
    <Button
      className={clsx(
        '!py-0.5 !px-0 !min-w-[120px]',
        { '!border-blue-500': !isLoading },
        className,
      )}
      variant="outlined"
      type="button"
      color="primary"
      onClick={handleClick}
      disabled={disabled || isLoading}
    >
      {isLoading ? (
        <div className="gap-2 flex items-center">
          <Spinner size={16} />
          Calling...
        </div>
      ) : 'Call for CCM'}
    </Button>
  );
}
